import {ServiceBase} from "../ServiceBase";
import {ICompaniesService} from "./companies.service.interface";
import {ILegacyCompanyViewModel} from "./legacy-company-view-model.interface";
import {CompanyModelConstructor, ICompanyModel} from "./company-model.interface";
import {IRegulatedCompanyModel} from "./regulated-company-model.interface";

export class CompaniesService extends ServiceBase implements ICompaniesService {
    async getLegacyCompanyByName(name: string): Promise<ILegacyCompanyViewModel> {
        return await this.services.sdk.getCompanyByName(name);
    }

    private async _getCompanyConstructor(companyIdentifier: string): Promise<CompanyModelConstructor> {
        switch (companyIdentifier) {
            case 'Play N Go':
                companyIdentifier = 'play-n-go';
                break;
        }

        try {
            companyIdentifier = companyIdentifier.toLowerCase();
            return (await import(`./companies-models/${companyIdentifier}/${companyIdentifier}.company-model`)).default;
        } catch (err) {
            this.services.logger.error(`Failed to get constructor for company ${companyIdentifier}`, err);
            throw err;
        }
    }

    async getCompany(companyIdentifier: string): Promise<ICompanyModel> {
        const CompanyConstructor = await this._getCompanyConstructor(companyIdentifier);
        return new CompanyConstructor(this.services);
    }

    async getRegulatedCompany(companyIdentifier: string): Promise<IRegulatedCompanyModel> {
        const company = await this.getCompany(companyIdentifier);
        return company.applyRegulation(this.services.regulation.current);
    }
}